import React, { useEffect } from 'react';
import { htmlToU } from './Nucleo/TermsofUse_gonucleo_EN_2026';
import { useDocumentTitle } from '../../../helpers/hooks';
import { BRANDING } from '../../../helpers/branding';
import LegalContentFrame from './LegalContentFrame';

export default function TermsOfUsePage() {

  useDocumentTitle('Terms of Use');

  useEffect(() => {
    if (BRANDING === 'IPLS') {
      window.location.href = 'https://ipls.online/terms-conditions';
    }
  }, []);

  if (BRANDING === 'NUCLEO') {
    return <LegalContentFrame html={htmlToU} title="Terms of Use" />;
  }

  return null;
}
